import { useNavigate } from 'react-router-dom';

export default function PaymentCancel() {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
            <div className="bg-white rounded-3xl shadow-2xl p-10 max-w-md w-full text-center">
                <div className="w-20 h-20 mx-auto mb-6 bg-gray-100 rounded-full flex items-center justify-center">
                    <span className="text-5xl">↩️</span>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">Đã huỷ thanh toán</h2>
                <p className="text-gray-500 mb-8">
                    Bạn đã huỷ quá trình thanh toán. Không có khoản phí nào bị tính.
                    Bạn có thể thử lại bất cứ lúc nào.
                </p>
                <div className="flex flex-col gap-3">
                    <button
                        onClick={() => navigate('/billing')}
                        className="w-full bg-blue-600 text-white py-3 rounded-xl font-semibold hover:bg-blue-700"
                    >
                        Quay lại trang Gói dịch vụ
                    </button>
                    <button
                        onClick={() => navigate('/dashboard')}
                        className="w-full text-gray-400 hover:text-gray-600 text-sm"
                    >
                        Về Dashboard
                    </button>
                </div>
            </div>
        </div>
    );
}
